exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#right-panel-root[data-v-8b0e9136] {\n  max-width:75%;\n  min-width:75%;\n  height:inherit;\n  background-color:white;\n  border:none;\n  -webkit-box-shadow: -1px 0px 5px grey;\n          box-shadow: -1px 0px 5px grey;\n  overflow: hidden;\n}\n#right-panel-filter-view[data-v-8b0e9136] {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n@media (max-width: 992px) {\n#right-panel-filter-view[data-v-8b0e9136] {\n    margin-top: -44px;\n    padding-top: 44px;\n}\n}\n@media (min-width: 993px) {\n#right-panel-filter-view[data-v-8b0e9136] {\n    margin-top: -123px;\n    padding-top: 123px;\n}\n}\n.imgClosePanel[data-v-8b0e9136] {\n  width: 32px;\n  height:32px;\n  margin-top:auto;\n  margin-bottom:auto;\n  float:right;\n}\n.navbar[data-v-8b0e9136] {\n  background-color: var(--headbandColor);\n  color: var(--headbandTextColor);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b0e9136","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/RightPanel.vue
// module id = 1592
// module chunks = 2